/**
 * Chemins de l'app parcourus dans cet onglet (HashRouter) : le chemin courant et le précédent, relevés par AppV2 à
 * chaque changement de route. Sert au bouton « Retour au planning » de la fiche cours, qui ne revient en arrière que si
 * l'entrée précédente est une page du planning (revue du 04/10 : venu de Mon compte, il ramenait à Mon compte).
 */
let current: string | null = null;
let previous: string | null = null;

export function recordPath(path: string): void {
  if (path === current) return;
  previous = current;
  current = path;
}

export function previousPath(): string | null {
  return previous;
}

/** Routes du planning (AppV2) : accueil, studio, semaine d'un studio, coach, type de cours. */
export function isPlanningPath(path: string | null): boolean {
  return path === '/' || path === '' || (!!path && /^\/(studio|coach|cours)\//.test(path));
}

/** Tests seulement. */
export function resetNavHistory(): void {
  current = null;
  previous = null;
}
